"use client"

import { createRoute, Outlet } from "@tanstack/react-router"

import { TopNav } from "@/components/layout/top-nav"
import AgentWorkspaceRoute from "./AgentWorkspaceRoute"

const MainAppRoute = createRoute({
  getParentRoute: () => AgentWorkspaceRoute,
  id: "main-app",
  component: MainApp,
})

export default MainAppRoute

/**
 * The ATS half of the shell. Routes live in the top bar now, so there is no
 * second sidebar nested inside the resizable panel — the left column belongs
 * entirely to the conversation list in `RobinWorkspace`.
 */
function MainApp() {
  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <TopNav />
      <main className="min-h-0 flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
